import { render, staticRenderFns } from "./PortalSidebarWrapper.vue?vue&type=template&id=72dfd9ce&scoped=true&"
import script from "./PortalSidebarWrapper.vue?vue&type=script&lang=js&"
export * from "./PortalSidebarWrapper.vue?vue&type=script&lang=js&"
import style0 from "./PortalSidebarWrapper.vue?vue&type=style&index=0&id=72dfd9ce&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72dfd9ce",
  null
  
)

export default component.exports